import { Box, Typography, useTheme } from "@mui/material";

export default function Trussfinancial() {
  const theme = useTheme();
  return (
    <Box
      display={"flex"}
      borderRadius={10}
      bgcolor={theme.palette.background.paper}
      mb={3}
      py={5}
      px={7}
      position="relative"
      justifyContent={"space-between"}
      alignItems={{ xs: "center", sm: "flex-start" }}
      flexDirection={{ xs: "column", sm: "row" }}
    >
      <Box py={{ xs: 0, sm: 2 }} mt={{ xs: 3, sm: 0 }} flex={1}>
        <Typography
          variant="h6"
          color={theme.palette.text.primary}
          textAlign={"left"}
        >
          You’re here because you’re exploring a smart way to use your home
          equity — and you're in the right place.{" "}
          <span style={{ fontFamily: "Pro Display Semibold" }}>NFTYDoor</span>{" "}
          offers fast, digital access to Home Equity Lines of Credit (HELOCs).
        </Typography>
      </Box>
    </Box>
  );
}
